class TabsSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = document.querySelectorAll(".tabs__button");
    this.blocks = document.querySelectorAll(".tabs__block");
    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => this.setActive(index));
    });
    
    // Додаємо класи до всіх таблиць у контенті
    this.addTableClasses();
  }

  addTableClasses() {
    // Знаходимо всі таблиці всередині tabs__table-content
    const tableContents = this.querySelectorAll(".tabs__table-content");
    
    tableContents.forEach((content) => {
      const tables = content.querySelectorAll("table");
      
      tables.forEach((table) => {
        // Додаємо клас до таблиці
        table.classList.add("tabs__table");
        
        // Обробляємо thead
        const thead = table.querySelector("thead");
        if (thead) {
          const headerRows = thead.querySelectorAll("tr");
          headerRows.forEach((row) => {
            row.classList.add("tabs__header-row");
            const cells = row.querySelectorAll("th, td");
            cells.forEach((cell) => {
              cell.classList.add("tabs__header-cell");
            });
          });
        }
        
        // Обробляємо tbody
        const tbody = table.querySelector("tbody");
        if (tbody) {
          const rows = tbody.querySelectorAll("tr");
          rows.forEach((row) => {
            row.classList.add("tabs__row");
            const cells = row.querySelectorAll("td, th");
            cells.forEach((cell) => {
              cell.classList.add("tabs__cell");
            });
          });
        }
        
        // Якщо немає thead/tbody, обробляємо всі рядки
        if (!thead && !tbody) {
          const rows = table.querySelectorAll("tr");
          rows.forEach((row, index) => {
            if (index === 0) {
              row.classList.add("tabs__header-row");
              const cells = row.querySelectorAll("th, td");
              cells.forEach((cell) => {
                cell.classList.add("tabs__header-cell");
              });
            } else {
              row.classList.add("tabs__row");
              const cells = row.querySelectorAll("td, th");
              cells.forEach((cell) => {
                cell.classList.add("tabs__cell");
              });
            }
          });
        }
      });
    });
  }

  setActive(index) {
    this.tabs.forEach((tab) => tab.classList.remove("tabs__button--active"));
    this.blocks.forEach((block) =>
      block.classList.remove("tabs__block--active")
    );

    this.tabs[index].classList.add("tabs__button--active");
    this.blocks[index].classList.add("tabs__block--active");
  }
}

customElements.define("tabs-section", TabsSection);
